import { useMemo } from 'react'
import type { Product } from 'src/components/restructure/product/types/product'
import { isAuthorityBadgeEligible } from 'src/utils/restructure/isAuthorityBadgeEligible'
import AuthorityBadgeIcon from 'src/components/Icons/AuthorityBadgeIcon'

const BADGE_TEXT = 'Testado por esportistas'

interface ProductAuthorityBadgeProps {
  product: Product
  className?: string
  textClassName?: string
}

export default function ProductAuthorityBadge({
  product,
  className,
  textClassName,
}: Readonly<ProductAuthorityBadgeProps>) {
  const isEligible = useMemo(() => {
    return isAuthorityBadgeEligible({ product })
  }, [product])

  if (!isEligible) {
    return null
  }

  return (
    <div
      className={`hidden items-center gap-1 rounded-full ${className ?? ''}`}
      data-testid="authority-badge"
      data-dy-id="authority-badge"
    >
      <AuthorityBadgeIcon width={16} height={16} />

      <span
        className={`font-inter font-semibold text-restructure-blue-8 uppercase mt-0.5 ${
          textClassName ?? 'text-xs'
        }`}
      >
        {BADGE_TEXT}
      </span>
    </div>
  )
}
